'use client';

import { MouseEvent } from 'react';
import { IconClose } from '@sympla/sympla-components/NavigationIcons';
import * as styles from './CloseButtonModal.css';

type CloseButtonModalProps = {
  ariaLabel: string;
  iconSize?: number;
  top: number;
  right: number;
  onClick: (e?: MouseEvent) => void;
}

function CloseButtonModal({
  ariaLabel, iconSize = 24, top, right, onClick,
}: CloseButtonModalProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className={styles.closeButtonModal}
      style={{ top: `${top}px`, right: `${right}px` }}
    >
      <IconClose width={iconSize} height={iconSize} />
    </button>
  );
}

export default CloseButtonModal;
